/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from "utils/styles/style_helpers";



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default theme =>({
    wiretransfer:{
            '& .griditem': {
                marginRight: pxToEm(30),
                marginTop: pxToEm(20),
                width: '100%',
                maxWidth: pxToEm(469),
                '& .field':{
                    width: '100%',
                    maxWidth: pxToEm(469)
                }
            }
        }
    })